import { createSlice } from "@reduxjs/toolkit";
export const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null,
    token: localStorage.getItem("token"),

    isLoading: false,
    error: false,
  },

  reducers: {
    registerStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    registerSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        token: action.payload.token || action.payload.access_token || null,
        userInfo: action.payload.user || action.payload,
      };
    },
    registerFailure: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    loginStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loginSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        token: action.payload.token || action.payload.access_token || null,
        userInfo: action.payload.user || action.payload,
      };
    },
    loginFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload || "Login failed",
      };
    },
    clearAlert: (state) => {
      return {
        ...state,
        error: false,
      };
    },
    logout: (state) => {
      return {
        ...state,
        userInfo: null,
        token: null,
error:false,
        isLoading: false,
      };
    },
    updateUserStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    updateUserSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        token: action.payload.token || action.payload.access_token || null,
        userInfo: action.payload.user || action.payload,
      };
    },
    updateUserFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    },
  },
});

export const {
  registerStart,
  registerSuccess,
  registerFailure,
  loginStart,
  loginSuccess,
  loginFailure,
  clearAlert,
  logout,
  updateUserFailure,
  updateUserStart,
  updateUserSuccess,
} = userSlice.actions;

export default userSlice.reducer;